import Layout from "../../../../components/Layout";
import BreadCrumb from "../../../../components/BreadCrumb";
import Button from "../../../../components/Button";
import { useEffect, useState } from "react";
import useStyles from "../../styles";
import useValidator from "../../../../hooks/useValidator";
import { toast } from "react-toastify";
import SelectGroup from "../../../../components/FormComponent/SelectGroup";
import { Grid, Menu, MenuItem, IconButton, FormControlLabel, Switch } from "@mui/material";
import InputGroup from "../../../../components/FormComponent/InputGroup";
import { httprequest } from "../../../../data/api";
import { useParams, useNavigate } from "react-router-dom";
import WidgetTitle from "../../../dashboard/components/WidgetTitle/WidgetTitle";
import { Icon } from "@iconify/react/dist/iconify.js";
import TextAreaGroup from "../../../../components/FormComponent/TextAreaGroup";
import PageLoader from "../../../../components/PageLoader";
import Select from "react-select";

const ADMIN_CLASS_ENDPOINT = "/api/v1/class";
const ENROLMENT_EXAM_ENDPOINT = "/api/v1/enrolment-exams";
const ENROLMENT_EXAM_CONFIG_ENDPOINT = "/api/v1/enrolment-exam-configs";
const UPLOAD_ENDPOINT = "/api/v1/upload";

const EditEnrolmentExam = () => {
  const [classData, setClassData] = useState([]);
  const { id } = useParams();
  const styles = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  // const [isDraftSaving, setIsDraftSaving] = useState(false);
  const [currentAnchor, setCurrentAnchor] = useState("");
  const [disabledInputs, setDisabledInputs] = useState({});
  const navigate = useNavigate();
  // const [questionImages, setQuestionImages] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [editEnrolExamValidator, showEditEnrolExamValidator] = useValidator();
  const [totalGrade, setTotalGrade] = useState(0);

  const handleClick = (event, queInd) => {
    setAnchorEl(event.currentTarget);
    setCurrentAnchor(queInd);
  };
  const handleAdditionalQueClose = () => {
    setAnchorEl(null);
  };

  const [editEnrolmentExam, setEDitEnrolmentExam] = useState({
    title: "",
    class_id: [],
    description: "",
    total_grade: 0,
    instruction: "",
    is_private: false,
    duration: 0,
    proctoring_level: "",
    browser_lockdown: false,
    questions: [
      {
        question_index: 1

      }
    ]
  });

  /**
 *  This function handles the addition of a new question to the enrolment exam.
 * It creates a new question object with default values and appends it to the existing questions array.
 * @description This function is triggered when the user wants to add an additional question to the exam.
 */
  const handleAdditionalQuestion = () => {
    const newQue = {
      question: "",
      question_index: editEnrolmentExam?.questions?.length + 1,
      type: "",
      answer: [],
      file: {},
      required: false,
      grade_point: "",
      options: []
    };

    setEDitEnrolmentExam((prevForm) => ({
      ...prevForm,
      questions: [...(prevForm.questions || []), newQue]
    }));
  };

  /**
  *   This function removes an additional choice from a specific question in the enrolment exam.
  * @description It filters out the choice at the specified index from the options of the question at queInd.
  * @param {*} index - The index of the choice to be removed.
  * @param {*} queInd - The index of the question from which the choice will be removed.
  */
  const removeAdditionalChoice = (index, queInd) => {
    const newQueArr = [...editEnrolmentExam.questions];
    const newChoiceArr = newQueArr[queInd]["options"]?.filter(
      (_item, ind) => ind !== index
    );
    newQueArr[queInd]["options"] = newChoiceArr;
    setEDitEnrolmentExam({ ...editEnrolmentExam, questions: newQueArr });
  };

  /**
   * This function handles the change in multiple choice options for a specific question.
   * @description It updates the options array of the question at queInd by replacing the option at index with the new value from the event.
   * @param {*} e - The event object containing the new value for the option.
   * @param {*} index - The index of the option being changed.
   * @param {*} queInd
   */
  const handleMultipleChoiceChange = (e, index, queInd) => {
    const { value } = e.target;

    const options = editEnrolmentExam.questions[queInd]["options"];
    const newOptionArr = [...options];

    newOptionArr[index] = value;
    const newQueArr = [...editEnrolmentExam.questions];
    newQueArr[queInd]["options"] = newOptionArr;
    setEDitEnrolmentExam({ ...editEnrolmentExam, questions: newQueArr });
  };

  /**
   * This function calculates the total grade for the enrolment exam.
   * @description It iterates through the questions in the exam, summing up the grade points of each question to get the total grade.
   */
  const calculateTotalGrade = () => {
    const total = editEnrolmentExam?.questions.reduce((sum, question) => {
      return sum + (parseFloat(question.grade_point) || 0);
    }, 0);
    setTotalGrade(total);
  };

  /**
   * This function removes the description of a specific question in the enrolment exam.
   * @param {*} index - The index of the question whose description will be removed.
   */
  const removeQueDescription = (index) => {
    const newQuestionArr = [...editEnrolmentExam.questions];
    delete newQuestionArr[index]["description"];
    setEDitEnrolmentExam({ ...editEnrolmentExam, questions: newQuestionArr });
  };

  /**
   * This function handles the change in the correct choice for a specific question.
   * @param {*} e - The event object containing the change in choice.
   * @param {*} optionIndex - The index of the option being changed.
   * @param {*} queInd - The index of the question to which the option belongs.
   */
  const handleCorrectChoiceChange = (e, optionIndex, queInd) => {
    const newQuestionArr = [...editEnrolmentExam.questions];

    // Check the type for the specific question based on (queInd)
    if (newQuestionArr[queInd]?.type === "multiple_choice") {
      // Update the state with the new questions array
      newQuestionArr[queInd]["answer"] = [optionIndex];
    } else if (newQuestionArr[queInd]?.type === "checkbox") {
      // For checkbox ( one or multiple correct answers allowed)
      const answers = newQuestionArr[queInd]["answer"] || [];

      if (e.target.checked) {
        // Add the option index if checked
        answers.push(optionIndex);
      } else {
        // Remove the option index if unchecked
        const answerIndex = answers.indexOf(optionIndex);
        if (answerIndex > -1) {
          answers.splice(answerIndex, 1);
        }
      }

      // Update answer in the question array
      newQuestionArr[queInd]["answer"] = answers;
    }

    // Set the updated questions array
    setEDitEnrolmentExam({ ...editEnrolmentExam, questions: newQuestionArr });
  };

  /**
 * This function handles the addition of an additional option to a specific question in the enrolment exam.
 * @description It appends a new empty option to the options array of the question at queInd.
 * @param {*} queInd - The index of the question to which the additional option will be added.
 */
  const handleAdditionalOptions = (queInd) => {
    const updatedQuestions = [...editEnrolmentExam.questions];

    updatedQuestions[queInd].options = [...updatedQuestions[queInd].options, [" "]];

    setEDitEnrolmentExam({
      ...editEnrolmentExam,
      questions: updatedQuestions
    });
  };

  /**
   *  This function handles the change in question type for a specific question.
   * * @description It updates the type of the question at the specified index and ensures that additional options are added if the options array is empty.
   * @param {*} e - The event object containing the change in question type.
   * @param {*} index - The index of the question whose type is being changed.
   */
  const handleQueTypeChange = (e, index) => {
    const { name, value } = e.target;
    const updatedQuestions = [...editEnrolmentExam.questions];
    updatedQuestions[index][name] = value;
    if (updatedQuestions[index].options.length === 0) {
      handleAdditionalOptions(index);
    }

    setEDitEnrolmentExam({
      ...editEnrolmentExam,
      questions: updatedQuestions
    });
  };

  /**
   * This function handles the deletion of a question from the enrolment exam.
   */
  const toggleQueDescriptionTrue = () => {
    const updatedQuestions = [...editEnrolmentExam.questions];
    updatedQuestions[currentAnchor]["description"] = "";
    setEDitEnrolmentExam({
      ...editEnrolmentExam,
      questions: updatedQuestions
    });
  };

  /**
   * This function handles the deletion of a question from the enrolment exam.
   * @description It removes the question at the specified index from the questions array.
   * @param {*} e - The event object containing the index of the question to be deleted.
   */
  const handleQueChange = (e, queInd) => {
    const { name, value } = e.target;
    const updatedQuestions = [...editEnrolmentExam.questions];
    updatedQuestions[queInd][name] = value;

    setEDitEnrolmentExam({
      ...editEnrolmentExam,
      questions: updatedQuestions
    });
  };

  /**
   * This function handles the deletion of a question from the enrolment exam.
   * @description It removes the question at the specified index from the questions array.
   * @param {*} e - The event object containing the index of the question to be deleted.
   * @param {*} queInd - The index of the question to be deleted.
   */
  const handleQuePointChange = (e, queInd) => {
    const { name, value } = e.target;
    const updatedQuestions = [...editEnrolmentExam.questions];
    updatedQuestions[queInd][name] = value;

    setEDitEnrolmentExam({
      ...editEnrolmentExam,
      questions: updatedQuestions
    });

    calculateTotalGrade();
  };

  // Handle Question Description of a Specific Question
  const handleQueDescChange = (e, queInd) => {
    const { name, value } = e.target;
    const updatedQuestions = [...editEnrolmentExam.questions];
    updatedQuestions[queInd][name] = value;

    setEDitEnrolmentExam({
      ...editEnrolmentExam,
      questions: updatedQuestions
    });
  };

  // Handle class select
  const handleMultipleAccessChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => ({ id: option?.value, name: option?.label }));
    setEDitEnrolmentExam((prev_class) => (
      { ...prev_class, class_id: selectedValues }
    ));
  };

  /**
   * This function fetches the enrolment exam data by its ID.
   * @description It retrieves the enrolment exam details from the API and sets the state with the fetched data.
   */
  const getEnrolmentExamById = () => {
    setIsLoading(true);
    httprequest.get(`${ENROLMENT_EXAM_ENDPOINT}/${id}`).then((res) => {
      // setAssignmentData(res?.data?.data);
      const data = res?.data?.data;
      const config = data?.config;
      setEDitEnrolmentExam({
        ...editEnrolmentExam,
        subject_id: data?.subject,
        title: data?.title,
        class_id: data?.classes,
        description: data?.description,
        total_grade: data?.total_grade,
        instruction: data?.instruction,
        is_private: data?.is_private ?? false,
        questions: data?.questions,
        duration: data?.duration,
        proctoring_level: config?.proctoring_requirements?.level ?? "",
        browser_lockdown: !!(config?.browser_lockdown_settings)
      });
      // setEditdableData(res?.data?.data);
      setIsLoading(false);
    }).catch((err) => {
      toast.error(err?.response?.data);
      setIsLoading(false);
    });
  };

  /**
   * This function handles the editing of an enrolment exam.
   * @description It validates the form data, updates the enrolment exam with the new data, and navigates to the enrolment exam list page upon success.
   */
  const buildQuestionsPayload = () => {
    const questions = editEnrolmentExam?.questions ?? [];

    return questions.map((q) => {
      const optionValues = (q.options || []).map((opt) => {
        if (typeof opt === "object" && opt !== null && (opt?.file_url || opt?.text != null)) {
          const textVal = opt?.text != null && opt.text !== "" ? opt.text : null;
          const fileVal = opt?.file_url ? { file_url: opt.file_url, upload_id: opt.upload_id } : null;

          return textVal ?? fileVal ?? opt;
        }

        return opt;
      });
      const item = {
        type: q.type,
        question_text: (q.question_text ?? q.question ?? "").trim(),
        file: q.file || null,
        options: optionValues,
        answer: Array.isArray(q.answer) ? q.answer : [],
        grade_point: Number(q.grade_point) || 0
      };
      if (q.id) item.id = q.id;

      return item;
    });
  };

  const handleEditAssignment = () => {
    if (editEnrolExamValidator.allValid()) {
      setIsEditing(true);
      const updatedClassIds = editEnrolmentExam?.class_id?.map((a_class) => (typeof a_class === "object" && a_class?.id != null ? a_class.id : a_class)) ?? [];
      const configPayload = {
        title: editEnrolmentExam?.title,
        class_id: updatedClassIds,
        description: editEnrolmentExam?.description ?? "",
        instruction: editEnrolmentExam?.instruction ?? "",
        duration: Number(editEnrolmentExam?.duration) || 0,
        is_private: !!editEnrolmentExam?.is_private,
        proctoring_requirements: editEnrolmentExam?.proctoring_level
          ? { level: editEnrolmentExam.proctoring_level }
          : null,
        browser_lockdown_settings: editEnrolmentExam?.browser_lockdown ? {} : null
      };
      const questionsPayload = buildQuestionsPayload();
      const updateConfig = () => httprequest.patch(`${ENROLMENT_EXAM_CONFIG_ENDPOINT}/${id}`, configPayload);
      const updateQuestions = () => (questionsPayload.length > 0
        ? httprequest.patch(`${ENROLMENT_EXAM_CONFIG_ENDPOINT}/${id}/questions`, { questions: questionsPayload })
        : Promise.resolve());

      updateConfig()
        .then(() => updateQuestions())
        .then((res) => {
          setIsEditing(false);
          toast.success(res?.data?.message ?? "Enrolment exam updated successfully.");
          navigate("/enrolments/enrolment-examination");
          getEnrolmentExamById();
        })
        .catch((err) => {
          setIsEditing(false);
          toast.error(err?.response?.data?.message);
        });
    } else {
      showEditEnrolExamValidator(true);
    }
  };

  // const handleDraftAssignment = () => {
  //   setIsDraftSaving(true);
  //   httprequest.post(`${ASSIGNMENT_DRAFT}${id}`, editEnrolmentExam).then((res) => {
  //     setIsDraftSaving(false);
  //     toast.success(res?.data?.message);
  //     getEnrolmentExamById();
  //   }).catch((err) => {
  //     setIsDraftSaving(false);
  //     showEditEnrolExamValidator(true);
  //     toast.error(err?.response?.data?.message);
  //   });
  // };

  /**
   * This function handles the deletion of a question from the enrolment exam.
   * @description It filters out the question with the specified index from the questions array and updates the state.
   * @param {*} question_ind - The index of the question to be deleted.
   */
  const handleDeleteQuestion = (question_ind) => {
    const allquestions = editEnrolmentExam?.questions;
    const questionToDelete = allquestions?.find((item) => item?.question_index === question_ind);
    const newQuestions = allquestions?.filter((item) => item?.question_index !== questionToDelete?.question_index);
    setEDitEnrolmentExam((prev) => ({
      ...prev,
      questions: newQuestions
    }));
  };

  const handleIconClick = (queInd) => {
    document.getElementById(`imageInput-${queInd}`).click();
  };

  const handleIconOptionClick = (i, queInd) => {
    document.getElementById(`imageInput-${i}${queInd}`).click();
  };

  /**
   * This function handles the change of an image for a specific question in the enrolment exam.
   * @description It uploads the selected image file to the server and updates the question with the uploaded image details.
   */
  const handleQuestionImageChange = async (event, queInd) => {
    if (event?.target?.files?.length > 0) {
      const file = event.target.files[0];

      // Prepare the image for upload
      const formData = new FormData();
      formData.append("file", file);

      try {
        // Upload the image
        const response = await httprequest.post(UPLOAD_ENDPOINT, formData);

        if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
          const uploadedImageDetails = {
            upload_id: response?.data?.data?.[0]?.upload_id,
            file_url: response?.data?.data?.[0]?.file_url
          };

          // Create a copy of the current question
          const updatedQuestion = {
            ...editEnrolmentExam?.questions[queInd],
            file: uploadedImageDetails
          };

          // Send only the updated question to the backend
          // await httprequest.patch(`${AN_ENROLMENT_EXAM}/${id}`, {
          //   ...editEnrolmentExam,
          //   questions: [updatedQuestion] // This update the modified question
          // });

          // Update local state after successful upload
          setEDitEnrolmentExam((prevForm) => ({
            ...prevForm,
            questions: prevForm.questions.map((question, index) => index === queInd ? updatedQuestion : question
            )
          }));

          toast.success(`Image added to question ${queInd + 1}`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    }
  };

  /**
   * This function removes the image from a specific question in the enrolment exam.
   * @description It updates the question at the specified index to remove the image details without making an API call.
   * @param {*} queInd - The index of the question from which the image will be removed.
   */
  const removeQueImage = async (queInd) => {
    const uploadId = editEnrolmentExam.questions[queInd]?.file?.upload_id;
    if (!uploadId) {
      toast.error("No upload ID found for this image.");

      return;
    }

    try {
      const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${uploadId}`);

      if (response?.status === 200) {
        setEDitEnrolmentExam((prevForm) => ({
          ...prevForm,
          questions: prevForm.questions.map((question, index) => index === queInd
            ? { ...question, file: {} }
            : question
          )
        }));
        toast.success(`Image removed from question ${queInd + 1}`);
      } else {
        toast.error(response?.data?.message || "Failed to delete image.");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "An error occurred during deletion.");
    }
  };

  /**
   * This function handles the change of an option image for a specific question.
   *  * @description It uploads the selected image file to the server and updates the specific option in the question's options array with the uploaded image details.
   * @param {*} event - The event object containing the file input change.
   */
  const handleOptionImageChange = async (event, optionIndex, questionIndex) => {
    if (event?.target?.files?.length > 0) {
      const file = event.target.files[0];

      // Disable the input while the file is being uploaded
      setDisabledInputs((prevDisabled) => ({
        ...prevDisabled,
        [questionIndex]: {
          ...prevDisabled[questionIndex],
          [optionIndex]: true
        }
      }));

      // Prepare to send the image to the upload endpoint
      const formData = new FormData();
      formData.append("file", file);

      try {
        // Upload the image
        const response = await httprequest.post(UPLOAD_ENDPOINT, formData);

        if (response?.status === 200 && response?.data?.data?.[0]?.file_url) {
          const uploadedImageDetails = {
            upload_id: response.data.data[0].upload_id,
            file_url: response.data.data[0].file_url
          };

          // Update only the specific option in the question at questionIndex
          const updatedOptions = editEnrolmentExam.questions[questionIndex].options.map(
            (option, oIndex) => oIndex === optionIndex ? uploadedImageDetails : option
          );

          const updatedQuestion = {
            ...editEnrolmentExam.questions[questionIndex],
            options: updatedOptions
          };

          // Update the editEnrolmentExam state with the modified question
          setEDitEnrolmentExam((prevForm) => ({
            ...prevForm,
            questions: prevForm.questions.map((question, index) => index === questionIndex ? updatedQuestion : question
            )
          }));

          // API call to update only the specific option of the particular question
          // await httprequest.patch(`${AN_ENROLMENT_EXAM}/${id}`, {
          //   ...editEnrolmentExam,
          //   questions: [updatedQuestion]
          // });

          toast.success(`Image added to option ${optionIndex + 1} in question ${questionIndex + 1}`);
        } else {
          toast.error(response?.data);
        }
      } catch (error) {
        toast.error(error?.response?.message);
      }
    }
  };

  /**
   * This function removes the image from a specific option in a question.
   * @description It updates the option at the specified index in the question's options array to remove the image details.
   * @param {*} optionIndex
   * @param {*} questionIndex
   */
  const removeOptionImage = async (optionIndex, questionIndex) => {
    const option = editEnrolmentExam.questions[questionIndex].options[optionIndex];
    if (!option?.upload_id) {
      toast.error("No upload ID found for this image.");

      return;
    }

    try {
      const response = await httprequest.delete(`${UPLOAD_ENDPOINT}/${option.upload_id}`);

      if (response?.status === 200) {
        const updatedOptions = editEnrolmentExam.questions[questionIndex].options.map(
          (opt, oIndex) => oIndex === optionIndex ? { ...opt, upload_id: "", file_url: "" } : opt
        );
        const updatedQuestion = {
          ...editEnrolmentExam.questions[questionIndex],
          options: updatedOptions
        };
        setEDitEnrolmentExam((prevForm) => ({
          ...prevForm,
          questions: prevForm.questions.map((question, index) => index === questionIndex ? updatedQuestion : question)
        }));
        toast.success(`Image removed from option ${optionIndex + 1} in question ${questionIndex + 1}`);
      } else {
        toast.error(response?.data?.message || "Failed to delete image.");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "An error occurred during deletion.");
    }
  };

  /**
   * This function fetches all admin classes from the API and sets the class data state.
   * @description It retrieves the class data and formats it for use in a select input.
   */
  const getAllAdminClasses = () => {
    httprequest
      .get(ADMIN_CLASS_ENDPOINT)
      .then((res) => {
        setClassData(
          res?.data?.data.map((a_class) => ({
            value: a_class?.id,
            label: a_class?.class_name
          }))
        );
      })
      .catch(() => {});
  };

  // This handles the Assignment Description input
  const handleEditEnrolmentExam = (e) => {
    const { name, value, type, checked } = e.target;
    setEDitEnrolmentExam({ ...editEnrolmentExam, [name]: type === "checkbox" ? checked : value });
  };

  useEffect(() => {
    calculateTotalGrade();
  }, [editEnrolmentExam?.questions]);

  useEffect(() => {
    getAllAdminClasses();
    getEnrolmentExamById();
  }, []);

  const options = [
    // {
    //   value: "paragraph",
    //   text: "Paragraph",
    //   icon: <Icon icon="carbon:text-short-paragraph" width="25" height="25" />
    // },
    {
      value: "multiple_choice",
      text: "Multiple Choice",
      icon: <Icon icon="mdi:radiobox-marked" width="25" height="25" />
    },
    {
      value: "checkbox",
      text: "Checkbox",
      icon: <Icon icon="ci:checkbox-check" width="25" height="25" />
    }
    // {
    //   value: "dropdown",
    //   text: "Dropdown",
    //   icon: <Icon icon="tabler:select" width="25" height="25" />
    // },
    // {
    //   value: "file_upload",
    //   text: "File Upload",
    //   icon: <Icon icon="basil:cloud-upload-outline" width="25" height="25" />
    // },
    // {
    //   value: "date",
    //   text: "Date",
    //   icon: (
    //     <Icon
    //       icon="material-symbols-light:date-range-sharp"
    //       width="25"
    //       height="25"
    //     />
    //   )
    // },
    // {
    //   value: "time",
    //   text: "Time",
    //   icon: <Icon icon="mingcute:time-line" width="25" height="25" />
    // }
  ];

  // const { questions } = editEnrolmentExam;

  return (
    <Layout
      children={
        <>
          <div className="breadcrumb-container">
            <div>
              <BreadCrumb
                link_one="/enrolments/enrolment-examination"
                link_one_name="All Enrolment Examination"
                active="Edit Enrolment Examination"
                description="Edit an Enrolment Examination"
              />
            </div>
            <div className="flex gap-10">
              {/* <Button
                variant="primaryoutline"
                buttonSize="fluid"
                color="btnfontprimary"
                onClick={handleDraftAssignment}
                buttonName="Save as Draft"
                isLoading={isDraftSaving}
              /> */}
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                buttonName="Edit Enrolment Examination"
                isLoading={isEditing}
                onClick={handleEditAssignment}
              />
            </div>
          </div>
          <div className="page-content">
            {isLoading ? (
              <PageLoader />
            ) :
              <>
                <WidgetTitle
                  title="Class Information"
                />
                <div className={`${styles.assignmentsection} margin-bottom-14`}>
                  <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className="multiple-select">
                        <p>Class</p>
                        <Select
                          isMulti
                          name="class_id"
                          closeMenuOnSelect={true}
                          options={classData}
                          onChange={handleMultipleAccessChange}
                          defaultValue={editEnrolmentExam?.class_id?.map(item => ({ label: item?.name, value: item?.id }))}
                          getOptionLabel={(option) => option.label}
                          getOptionValue={(option) => option.value}
                        />
                      </div>
                      {editEnrolExamValidator.message(
                        "class_id",
                        editEnrolmentExam?.class_id,
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <InputGroup
                        label="Subject"
                        margin="normal"
                        inputType="text"
                        inputName="subject"
                        defaultValue={editEnrolmentExam?.subject_id}
                        onChange={handleEditEnrolmentExam}
                        required
                      />
                      {editEnrolExamValidator.message(
                        "subject",
                        editEnrolmentExam?.subject_id,
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <InputGroup
                        label="Duration"
                        margin="normal"
                        inputType="number"
                        inputName="duration"
                        defaultValue={editEnrolmentExam?.duration}
                        placeHolder="Set Duration in Minutes"
                        onChange={handleEditEnrolmentExam}
                        required
                      />
                      {editEnrolExamValidator.message(
                        "Duration",
                        editEnrolmentExam?.duration,
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <InputGroup
                        label="Total Grade"
                        margin="normal"
                        inputType="number"
                        inputName="total_grade"
                        placeHolder="Set Duration in Minutes"
                        value={totalGrade}
                        disabled
                        onChange={handleEditEnrolmentExam}
                        required
                      />
                      {editEnrolExamValidator.message(
                        "Total Grade",
                        editEnrolmentExam?.total_grade,
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <label className={styles.enterque}>
                        <input
                          className="margin-top-5"
                          type="checkbox"
                          name="is_private"
                          checked={!!editEnrolmentExam?.is_private}
                          onChange={handleEditEnrolmentExam}
                        />
                        {" "}Visibility (Private)
                      </label>
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <SelectGroup
                        label="Proctoring requirements"
                        children={(
                          <select
                            name="proctoring_level"
                            value={editEnrolmentExam?.proctoring_level ?? ""}
                            onChange={handleEditEnrolmentExam}
                          >
                            <option value="">--- Select ---</option>
                            <option value="none">None</option>
                            <option value="basic">Basic</option>
                            <option value="strict">Strict</option>
                          </select>
                        )}
                      />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 8 }}>
                        <FormControlLabel
                          control={(
                            <Switch
                              name="browser_lockdown"
                              checked={!!editEnrolmentExam?.browser_lockdown}
                              onChange={handleEditEnrolmentExam}
                              color="primary"
                            />
                          )}
                          label="Browser lockdown"
                        />
                      </div>
                    </Grid>
                  </Grid>
                </div>
                <div className={`${styles.assignmentsection} margin-bottom-14`}>
                  <Grid container spacing={2}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <InputGroup
                        label="Enrolment Examination Title"
                        margin="normal"
                        inputType="text"
                        defaultValue={editEnrolmentExam?.title}
                        inputName="title"
                        onChange={handleEditEnrolmentExam}
                        required
                      />
                      {editEnrolExamValidator.message(
                        "title",
                        editEnrolmentExam?.title,
                        "required"
                      )}
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className={styles.inputmargin}>
                        <TextAreaGroup
                          label="Enrolment Examiantion Instruction"
                          inputName="instruction"
                          margin="normal"
                          defaultValue={editEnrolmentExam?.instruction}
                          placeholder=""
                          onChange={handleEditEnrolmentExam}
                        />
                      </div>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <div className={styles.inputmargin}>
                        <TextAreaGroup
                          label="Description"
                          inputName="description"
                          defaultValue={editEnrolmentExam?.description}
                          margin="normal"
                          placeholder=""
                          onChange={handleEditEnrolmentExam}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </div>
                <div className={styles.assignmentsection}>
                  <Grid container spacing={2}>
                    {editEnrolmentExam?.questions?.map((question, queInd) => (
                      <>
                        <Grid item lg={12} md={12} sm={12} xs={12} key={queInd}>
                          <div className={styles.quesaction}>
                            <label className={styles.enterque}> Question {queInd + 1}<span className="input-required"> *</span></label>
                            <div>
                              {editEnrolmentExam?.questions?.length > 1 ? (
                                <>
                                  <Icon
                                    icon="material-symbols:delete-outline"
                                    width="20"
                                    height="20"
                                    className="delete-icon"
                                    onClick={() => handleDeleteQuestion(question?.question_index, queInd)}
                                  />
                                </>
                              ) : null}
                            </div>
                          </div>
                          <div className={styles.textandimgmain}>
                            <div className={styles.textandimg}>
                              <input
                                type="text"
                                placeholder="Type Question"
                                name="question"
                                value={question?.question}
                                onChange={(e) => {
                                  handleQueChange(e, queInd);
                                }}
                              />
                              {editEnrolExamValidator.message(
                                `Question ${queInd + 1}`,
                                editEnrolmentExam?.questions[queInd]?.question,
                                "required"
                              )}
                              <div onClick={() => handleIconClick(queInd)} className={styles.queimg}>
                                <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                                <input
                                  type="file"
                                  accept="image/*"
                                  id={`imageInput-${queInd}`}
                                  multiple
                                  onChange={(e) => handleQuestionImageChange(e, queInd)}
                                  style={{ display: "none" }}
                                />
                              </div>
                              {/* Image preview */}
                              <div className={styles.preiewcont}>
                                {editEnrolmentExam?.questions[queInd]?.file?.file_url && (
                                  <>
                                    <img
                                      src={editEnrolmentExam?.questions[queInd]?.file?.file_url}
                                      alt={`Selected for question ${queInd + 1}`}
                                    />
                                    <Icon
                                      icon="material-symbols:delete-outline"
                                      width="20"
                                      height="20"
                                      className="delete-icon"
                                      onClick={() => removeQueImage(queInd)}
                                    />
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </Grid>
                        {/* For Question Description */}
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {"description" in question ? (
                            <div className="margin-top full-width">
                              <div className=" flex gap-10 justify-items-space">
                                <label className={styles.enterque}>Question Description</label>
                                <div>
                                  <div
                                    className="delete-icon"
                                    onClick={() => removeQueDescription(queInd)}
                                  >
                                    <Icon
                                      icon="ooui:close"
                                      width="20"
                                      height="20"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className={styles.textandimgmain}>
                                <div className={styles.textandimg}>
                                  <input
                                    type="text"
                                    placeHolder="Enter Description"
                                    name="description"
                                    value={question?.description}
                                    onChange={(e) => handleQueDescChange(e, queInd)}
                                  />
                                  <></>
                                  <div onClick={handleIconClick} className={styles.queimg}>
                                    <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                                    <input
                                      type="file"
                                      accept="image/*"
                                      id="imageInput"
                                      multiple
                                      disabled
                                      onChange={handleOptionImageChange}
                                      style={{ display: "none" }}
                                    />
                                  </div>
                                  {/* Image preview */}
                                  {/* <div className={styles.preiewoptioncont}>
                                    {optionimages.map((optionimage, index) => (
                                      <img
                                        key={index}
                                        src={optionimage}
                                        alt={`Selected ${index}`}
                                      />
                                    ))}
                                  </div> */}
                                </div>
                              </div>
                              {/* <div className="width-full">
                                <InputGroup
                                  label="Question Description"
                                  margin="normal"
                                  placeHolder="Enter Description"
                                  inputType="text"
                                  value={question?.description}
                                  inputName="description"
                                  onChange={(e) => handleQueDescChange(e, queInd)}
                                />
                              </div> */}
                            </div>
                          ) : null}
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <InputGroup
                            className={styles.pointsInput}
                            label="Question Point"
                            inputType="number"
                            inputMin={1}
                            inputName="grade_point"
                            placeHolder="Enter Question Points"
                            value={question?.grade_point}
                            onChange={(e) => {
                              handleQuePointChange(e, queInd);
                            }}
                          />
                          {editEnrolExamValidator.message(
                            `Question ${queInd + 1} Grade Point`,
                            editEnrolmentExam?.questions[queInd]?.grade_point,
                            "required"
                          )}
                        </Grid>
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                          <SelectGroup
                            label="Add Answer Type"
                            required
                            children={
                              <select
                                name="type"
                                value={question?.type}
                                onChange={(e) => handleQueTypeChange(e, queInd)}
                              >
                                <option value="">--- Select ---</option>
                                {options?.map((label) => {
                                  return (
                                    <option
                                      key={label?.key}
                                      value={label?.value}
                                    >
                                      <Icon
                                        className={`${styles.add_question_color}`}
                                        icon="flat-color-icons:plus"
                                        width="24"
                                        height="24"
                                      />
                                      {label?.text}
                                    </option>
                                  );
                                })}
                              </select>
                            }
                          />
                          {editEnrolExamValidator.message(
                            `Question ${queInd + 1}Question Type`,
                            editEnrolmentExam?.questions[queInd]?.type,
                            "required"
                          )}
                        </Grid>
                        {/* Checkbox */}
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {question?.type === "checkbox" ? (
                            <>
                              <Grid container spacing={2} mt={1}>
                                {question?.options?.map((checkbox, i) => {
                                  return (
                                    <Grid
                                      item
                                      lg={6}
                                      md={6}
                                      sm={12}
                                      xs={12}
                                      key={i + 1}
                                    >
                                      <div>
                                        <div className=" flex gap-10 justify-items-space">
                                          <label className={styles.enterque}>Option {i + 1}<span className="input-required"> *</span></label>
                                          {/* if checkbox option is more thatn 1, show close*/}
                                          {question?.options?.length > 1 ? (
                                            <Icon
                                              onClick={() => {
                                                removeAdditionalChoice(i, queInd);
                                              }}
                                              className="delete-icon"
                                              icon="ooui:close"
                                              width="20"
                                              height="20"
                                            />
                                          ) : null}
                                        </div>
                                        <div className={styles.textandimgmain}>
                                          <div className={styles.textandimg}>
                                            <input
                                              type="text"
                                              placeholder="Enter option"
                                              name="question"
                                              value={checkbox?.file_url ? "" : checkbox}
                                              disabled={checkbox?.file_url || disabledInputs[queInd]?.[i]}
                                              onChange={(e) => handleMultipleChoiceChange(e, i, queInd)}
                                            />
                                            {/* {que?.type === "paragraph" ? (
                                              <div className={styles.inputmargin}>
                                                <TextAreaGroup
                                                  margin="normal"
                                                  placeholder=""
                                                // disabled
                                                />
                                              </div>
                                            ) : null} */}
                                            <></>
                                            <div onClick={() => handleIconOptionClick(i, queInd)} className={styles.queimg}>
                                              <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                                              <input
                                                type="file"
                                                accept="image/*"
                                                id={`imageInput-${i}${queInd}`}
                                                // multiple
                                                onChange={(e) => handleOptionImageChange(e, i, queInd)}
                                                style={{ display: "none" }}
                                              />
                                            </div>
                                            {/* Image preview */}
                                            <div className={styles.preiewoptioncont}>
                                              {checkbox?.file_url && (
                                                <>
                                                  <img
                                                    src={checkbox.file_url}
                                                    alt={`Option ${i + 1}`}
                                                  />
                                                  <Icon
                                                    icon="material-symbols:delete-outline"
                                                    width="20"
                                                    height="20"
                                                    className="delete-icon"
                                                    onClick={() => removeOptionImage(i, queInd)}
                                                  />
                                                </>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        {editEnrolExamValidator.message(
                                          `Option ${i + 1}`,
                                          editEnrolmentExam?.questions[queInd]?.options[i],
                                          "required"
                                        )}
                                        <div className="text-align-left">
                                          <div
                                            className="flex gap-10 align-items-center justify-items-space margin-top-5 "
                                          >
                                            <div className={styles.correctcontainer}>
                                              <input
                                                type="checkbox"
                                                name={`answer-${queInd}`}
                                                value={i}
                                                id={`correct-${queInd}-${i}`}
                                                defaultChecked={editEnrolmentExam?.questions[queInd]?.answer?.includes(i)}
                                                onChange={(e) => handleCorrectChoiceChange(e, i, queInd)}
                                              />
                                              <label
                                                className={styles.correctlabel}
                                                htmlFor={`correct-${queInd}-${i}`}
                                              >
                                              is correct
                                              </label>
                                            </div>
                                          </div>
                                          {editEnrolExamValidator.message(
                                            `question ${queInd + 1} answer`,
                                            editEnrolmentExam?.questions[queInd]["answer"].length > 0 ? editEnrolmentExam?.questions[queInd] : null,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                    </Grid>
                                  );
                                })}
                              </Grid>
                              <div
                                className={styles.addoption}
                                onClick={() => handleAdditionalOptions(queInd)}
                              >
                                <Icon
                                  icon="octicon:feed-plus-16"
                                  width="14"
                                  height="14"
                                />
                                <p>Add another checkbox</p>
                              </div>
                            </>
                          ) :
                            <>
                              {/* Type === multiple choice */}
                              <Grid container spacing={2} mt={1}>
                                {question?.options?.map((radio, i) => {
                                  return (
                                    <Grid
                                      item
                                      lg={6}
                                      md={6}
                                      sm={12}
                                      xs={12}
                                      key={i + 1}
                                    >
                                      <div>
                                        <div className=" flex gap-10 justify-items-space">
                                          <label className={styles.enterque}>Option {i + 1} <span className="input-required"> * </span></label>
                                          {/* if checkbox option is more thatn 1, show close*/}
                                          {question?.options?.length > 1 ? (
                                            <Icon
                                              onClick={() => {
                                                removeAdditionalChoice(i, queInd);
                                              }}
                                              className="delete-icon"
                                              icon="ooui:close"
                                              width="20"
                                              height="20"
                                            />
                                          ) : null}
                                        </div>
                                        <div className={styles.textandimgmain}>
                                          <div className={styles.textandimg}>
                                            <input
                                              type="text"
                                              placeholder="Enter option"
                                              name="question"
                                              disabled={radio?.file_url || disabledInputs[queInd]?.[i]}
                                              value={radio?.file_url ? "" : radio}
                                              onChange={(e) => handleMultipleChoiceChange(e, i, queInd)}
                                            />
                                            <></>
                                            <div onClick={() => handleIconOptionClick(i, queInd)} className={styles.queimg}>
                                              <Icon icon="basil:image-outline" width="20" height="20" style={{ color: "#858585" }} />
                                              <input
                                                type="file"
                                                accept="image/*"
                                                id={`imageInput-${i}${queInd}`}
                                                // multiple
                                                onChange={(e) => handleOptionImageChange(e, i, queInd)}
                                                style={{ display: "none" }}
                                              />
                                            </div>
                                            {/* Image preview */}
                                            <div className={styles.preiewoptioncont}>
                                              {radio?.file_url && (
                                                <>
                                                  <img
                                                    src={radio.file_url}
                                                    alt={`Option ${i + 1}`}
                                                  />
                                                  <Icon
                                                    icon="material-symbols:delete-outline"
                                                    width="20"
                                                    height="20"
                                                    className="delete-icon"
                                                    onClick={() => removeOptionImage(i, queInd)}
                                                  />
                                                </>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        {editEnrolExamValidator.message(
                                          `Option ${i + 1}`,
                                          editEnrolmentExam?.questions[queInd]?.options[i],
                                          "required"
                                        )}
                                        <div className="text-align-left">
                                          <div
                                            className="flex gap-10 align-items-center justify-items-space margin-top-5 "
                                          >
                                            <div className={styles.correctcontainer}>
                                              <input
                                                type="radio"
                                                name={`answer${queInd}`}
                                                value={i}
                                                id={`correct-${queInd}-${i}`}
                                                defaultChecked={editEnrolmentExam?.questions[queInd]?.answer?.includes(i)}
                                                onChange={(e) => handleCorrectChoiceChange(e, i, queInd)}
                                              />
                                              <label
                                                className={styles.correctlabel}
                                                htmlFor={`correct-${queInd}-${i}`}
                                              >
                                          is correct
                                              </label>
                                            </div>
                                          </div>
                                          {editEnrolExamValidator.message(
                                            `question ${queInd + 1} answer`,
                                            editEnrolmentExam?.questions[queInd]["answer"].length > 0 ? editEnrolmentExam?.questions[queInd] : null,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                    </Grid>
                                  );
                                })}
                              </Grid>
                              <div
                                className={styles.addoption}
                                onClick={() => handleAdditionalOptions(queInd)}
                              >
                                <Icon
                                  icon="octicon:feed-plus-16"
                                  width="14"
                                  height="14"
                                />
                                <p>Add another option</p>
                              </div>
                            </>}
                        </Grid>
                        <div className={styles.editquestionfooter}>
                          <div className="flex gap-10 align-items-center justifyRight">
                            {/* Conditionally render the IconButton only if there is no description */}
                            {!question?.description && (
                              <IconButton
                                aria-label="more"
                                id="long-button"
                                aria-controls={open ? "long-menu" : null}
                                aria-expanded={open ? "true" : null}
                                aria-haspopup="true"
                                onClick={(e) => handleClick(e, queInd)}
                              >
                                <Icon
                                  icon="radix-icons:dots-vertical"
                                  width="20"
                                  height="20"
                                />
                                <label className={styles.enterque}>More</label>
                              </IconButton>
                            )}
                          </div>
                        </div>
                        <Menu
                          id="basic-menu"
                          MenuListProps={{
                            "aria-labelledby": "basic-button"
                          }}
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleAdditionalQueClose}
                        >
                          <MenuItem
                            onClick={() => {
                              toggleQueDescriptionTrue();
                              handleAdditionalQueClose();
                            }}
                          >
                          Add Description on Question
                          </MenuItem>
                        </Menu>
                      </>
                    ))}
                  </Grid>
                  <div
                    className={styles.addque}
                  >
                    <Icon icon="octicon:feed-plus-16" width="16" height="16" />
                    <p onClick={handleAdditionalQuestion}>Add question</p>
                  </div>
                  <div className={styles.wrapper}>
                    <Button
                      variant="primary"
                      color="btndefault"
                      buttonSize="full"
                      buttonName="Edit Enrolment Examination"
                      onClick={handleEditAssignment}
                      isLoading={isEditing}
                    />
                  </div>
                </div>
              </>
            }
          </div>
          {/* <ToastContainer /> */}
        </>
      }
    />
  );
};

export default EditEnrolmentExam;
